export default [
  {
    path: "/statistics",
    name: "statistics",
    component: () => import("@/views/statistics"),
    meta: {
      title: "数据统计",
      keepAlive: true,
    },
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("@/views/settings"),
    meta: {
      title: "审核配置",
      keepAlive: true,
    },
  },
  {
    path: "/approval",
    name: "approval",
    component: () => import("@/views/approval"),
    meta: {
      title: "数据审核",
      keepAlive: true,
    },
  },
  {
    path: "/supplies",
    name: "supplies",
    component: () => import("@/views/supplies"),
    meta: {
      title: "物料管理(新)",
      keepAlive: true,
    },
  },
  {
    path: "/materiel",
    name: "materiel",
    component: () => import("@/views/about.vue"),
    meta: {
      title: "物料管理",
      keepAlive: true,
    },
    children: [
      {
        path: "category",
        name: "物料类别",
        component: () => import("@/views/materiel/category"),
      },
      {
        path: "manage",
        name: "物料管理",
        component: () => import("@/views/materiel/manage"),
      },
    ],
  },
  {
    path: "/warehouse",
    name: "出入库管理",
    component: () => import("@/views/about.vue"),
    meta: {
      title: "出入库管理",
      keepAlive: true,
    },
    children: [
      {
        path: "inventory",
        name: "库存管理",
        component: () => import("@/views/warehouse/inventory"),
      },
      {
        path: "inStorage",
        name: "入库管理",
        component: () => import("@/views/warehouse/inStorage"),
      },
      {
        path: "outStorage",
        name: "出库管理",
        component: () => import("@/views/warehouse/outStorage"),
      },
      {
        path: "requisition",
        name: "领料申请",
        component: () => import("@/views/warehouse/requisition"),
      },
      {
        path: "printDialog",
        name: "打印页面",
        component: () => import("@/views/warehouse/printDialog"),
      },
      {
        path: "keyMaterialsScrap",
        name: "重点物料报废及入库",
        component: () => import("@/views/warehouse/keyMaterialsScrap"),
      },
      {
        path: "keyMaterialsLife",
        name: "重点物料生命周期",
        component: () => import("@/views/warehouse/keyMaterialsLife"),
      },
    ],
  },
  {
    path: "/check",
    name: "check",
    component: () => import("@/views/check/inventory"),
    meta: {
      title: "库存盘点",
      keepAlive: true,
    },
  },
  {
    path: "/adjustment",
    name: "adjustment",
    component: () => import("@/views/check/adjustment"),
    meta: {
      title: "库存盘点",
      keepAlive: true,
    },
  },
  {
    path: "/allot",
    name: "allot",
    component: () => import("@/views/allot"),
    meta: {
      title: "调拨管理",
      keepAlive: true,
    },
  },
  {
    path: "/stash",
    name: "stash",
    component: () => import("@/views/stash"),
    meta: {
      title: "仓库管理",
      keepAlive: true,
    },
  },
  {
    path: "/supplier",
    name: "supplier",
    component: () => import("@/views/supplier"),
    meta: {
      title: "供应商管理",
      keepAlive: true,
    },
  },
  {
    path: "/project",
    name: "project",
    component: () => import("@/views/project"),
    meta: {
      title: "工程材料管理",
      keepAlive: true,
    },
  },
];
